import { useEffect } from "@wordpress/element";
import { useDispatch, useSelector } from "react-redux";
import {
	fetchPaymentMethods,
	selectPaymentMethods,
} from "store/vino/paymentMethodsSlice";
import PaymentMethodList from "./PaymentMethodList";

const PaymentMethods = () => {
	const dispatch = useDispatch();
	const paymentMethods = useSelector(selectPaymentMethods);
	
	useEffect(() => {
		dispatch(fetchPaymentMethods());
	}, [dispatch]);

	return (
		<div className="flex flex-col flex-auto flex-shrink-0 w-full">
			<div className="flex flex-col flex-1 max-w-2xl w-full mx-auto px-8">
				<PaymentMethodList paymentMethods={paymentMethods} />
			</div>
		</div>
	);
};

export default PaymentMethods;
